import React, {useEffect, useRef} from 'react';
import { useReactToPrint } from 'react-to-print';

import logo from '../assets/logo_patos.png';
import brasao from '../assets/brasao.png';


export const DialogMedia = ({ visible, setVisible, lista, intervaloDatas }) => {
    const cssText = `
    #print-content {
        font-family: 'Open Sans', sans-serif;
        width: 100%;
        text-align: center;
        font-size: 12px;
    }

    img {
            margin-top: 25px;
            width: 100%;
            max-width: 100px;
            height: auto;
            display: block;
        }

        .header-img {
            display: flex;
            justify-content: center;
        }

        .header {
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        .header h4 {
            margin: 0px;
            padding: 0px;
        }


    `

    const formatCurrency = (value) => {
        return value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL' ,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    const formatQuilos = (value) => {
        return value.toLocaleString("pt-BR", {
            style: "unit",
            unit: "kilogram",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    const listTotal = () => {
        let totalQuantidade = lista.reduce((itemAnterior, item) => {
                return itemAnterior + item.total;
          }, 0);
        return (
            <span style={{float: "right", width: "18%"}}><h4>Total: {formatQuilos(totalQuantidade)}</h4></span>
        )
    }

    const listMunicipio = (list) => {
        return (
            list.map((item) => {
                return (

                    <tr key={item.id} >
                        {item.total ?
                            <td width="400px" align='center'><span><b>{item.municipio}</b></span></td>
                            :
                            <td width="400px" align='center'><span>{item.municipio}</span></td>
                        }
                        {item.total ?
                            <td width="100px" align='center'><span> <b> {formatQuilos(item.qtde).replace(" kg", "")} </b> </span></td>
                            :
                            <td width="100px" align='center'><span> {formatQuilos(item.qtde).replace(" kg", "")}</span></td>
                        }
                    </tr>
                )

            })
        )
    }

    const listaMedia = (() => {
        let itemAnterior = null;
        let Total = 0;

        var listTemp = [];
        var listTempItens = [];

        var temp = {};
        var tempItem = {};

        lista.forEach((item) => {

            if (itemAnterior == null || itemAnterior.id !== item.id) {

                if (itemAnterior != null && itemAnterior.id !== item.id) {
                    tempItem = {
                        "municipio": "TOTAL GERAL",
                        "qtde": Total,
                        "total": true
                    }

                    listTempItens.push(tempItem);

                    listTempItens = [];
                    Total = 0;
                }

                temp = {
                    "id": item.id,
                    "nome": item.nome,
                    "unPadrao": item.unPadrao,
                    "valorUn": item.valorUn,
                }
                tempItem = {
                    "municipio": item.municipio,
                    "qtde": item.total,
                    "total": false
                }

                //listTemp.push(temp);
                listTempItens.push(tempItem);

                temp["itens"] = listTempItens;

                listTemp.push(temp);

            } else {

                tempItem = {
                    "municipio": item.municipio,
                    "qtde": item.total
                }

                listTempItens.push(tempItem);


            }

            itemAnterior = temp;
            Total = Total + item.total;

        }
        )

        tempItem = {
            "municipio": "TOTAL GERAL",
            "qtde": Total,
            "total": true
        }

        listTempItens.push(tempItem);

        return listTemp.map((item) => {
            let id = 1;
            item.itens.forEach(i => {
                i.id = id++;
            });

            return (
                <tr key={item.id} style={item.id === itemAnterior ? { borderTop: '0' } : { borderBottom: '2px' }}>


                    <td width="230px" align='center'><span>{item.nome.toUpperCase()}</span></td>


                    <td width="130px" align='center'><span>{item.unPadrao}</span></td>


                    <td width="230px" align='center'><span> {formatCurrency(item.valorUn)}</span></td>

                    <td width="600px" align='center'>
                        <table  >

                            {listMunicipio(item.itens)}

                        </table>

                    </td>

                    {/* {listQtde(item.itens)} */}

                </tr>
            )
        })
    })

    // const datas = intervaloDatas => {
    //     return (
    //         <li>
    //             <b>Data inicial:</b>{new Date(intervaloDatas.dataInicial).toLocaleDateString("pt-BR")}<br></br>
    //             <b>Data final:</b>{new Date(intervaloDatas.dataFinal).toLocaleDateString("pt-BR")}<br></br>
    //         </li>
    //     )
    // }

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef, pageStyle: cssText });

    useEffect(() => {


        if (visible) {
            reactToPrintFn();
            setVisible(false);
        }

    }, [visible, setVisible, reactToPrintFn])

    return (
        <div style={{ 'display': 'none'}}>

            <div id="print-content" ref={contentRef}>

                <div className="p-d-flex p-ai-center p-flex-column header">

                    <table>
                        <tr>
                            <th>
                                <div className="p-d-flex p-jc-right header-img">
                                    <img
                                        id="img"
                                        className='img'
                                        alt="brasao"
                                        src={brasao}
                                    />
                                </div>
                            </th>
                            <th>
                                <div className="p-d-flex p-jc-center header-img " >
                                    <h2> <span> MUNICÍPIO DE PATOS DE MINAS / SEC. MUNICIPAL DE AGRIC. PEC. E ABASTECIMENTO </span> <br /> <br />
                                        CEASA REGIONAL <br /> <br />
                                        BOLETIM DE CAPACITAÇÃO ESTATÍSTICA </h2>
                                </div>
                            </th>
                            <th>
                                <div className="p-d-flex p-jc-left header-img">
                                    <img
                                        id="img"
                                        alt="Logo"
                                        src={logo}
                                    />
                                </div>
                            </th>

                        </tr>

                    </table>

                    <h3> Período de Apuração: {new Date(intervaloDatas.dataInicial).toLocaleDateString("pt-BR")} à {new Date(intervaloDatas.dataFinal).toLocaleDateString("pt-BR")}</h3>
                </div>

                <table width="100%" border="1" cellPadding="0px" cellSpacing="0">
                    <thead>
                        <tr>
                            <th width="100px" ><i>Produto</i></th>
                            <th width="100px" ><i>Un Padrão</i></th>
                            <th width="100px" ><i>Valor Médio</i></th>
                            <th width="500px" align='center'><i>
                                <table>
                                    <th width="400px" align='center'><h4><i>Municipio</i></h4></th>
                                    <th width="100px" align='center'><h4><i>Qtde</i></h4></th>
                                </table>
                            </i>
                            </th>

                        </tr>
                    </thead>

                    <tbody>
                        {listaMedia()}
                    </tbody>

                </table>
                <footer>
                    <div style={{width: "100%", textAlign: "center"}}>
                        <table style={{float: "right", width: "100%"}} border="1" cellPadding="0px" cellSpacing="0">
                            {listTotal()}
                        </table>
                    </div>
                </footer>
            </div>



        </div>
    );
}
